import React from 'react';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

const bugsnagClient = bugsnag({
  apiKey: '40c193b1cee9cddab6928e1a39f71c71',
  releaseStage: process.env.NODE_ENV,
  notifyReleaseStages: [
    'production',
    'staging'
  ]
});
bugsnagClient.use(bugsnagReact, React);

const getBugsnagErrorBoundary = ({ user }) => {
  bugsnagClient.user = user
  return bugsnagClient.getPlugin('react');
};

export default getBugsnagErrorBoundary;
